import * as api from 'dashboard/resources/bond-renewal.api';
import actionTypes from './action-types';

export const downloadBondRenewalReportRequest = () => ({
  type: actionTypes.DOWNLOAD_BOND_RENEWAL_REPORT_REQUEST,
});

export const downloadBondRenewalReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_BOND_RENEWAL_REPORT_SUCCESS,
});

export const downloadBondRenewalReportFailure = () => ({
  type: actionTypes.DOWNLOAD_BOND_RENEWAL_REPORT_FAILURE,
});

export const downloadBondRenewalReport =
  (extension, id = null) =>
  (dispatch, getState) => {
    try {
      const { session } = getState();
      const retailerId = id || session.retailer.retailerId;

      dispatch(downloadBondRenewalReportRequest());
      dispatch(downloadBondRenewalReportSuccess());
      return api.downloadBondRenewalReport(extension, retailerId);
    } catch (error) {
      console.error('DOWNLOAD_BOND_RENEWAL_REPORT', error);
      dispatch(downloadBondRenewalReportFailure());
    }
  };

export const fetchBondRenewalRequest = () => ({
  type: actionTypes.FETCH_BOND_RENEWAL_REQUEST,
  isLoading: true,
});

export const fetchBondRenewalSuccess = ({ stores, storeCount }) => ({
  type: actionTypes.FETCH_BOND_RENEWAL_SUCCESS,
  stores,
  storeCount,
  isLoading: false,
});

export const fetchBondRenewalFailure = () => ({
  type: actionTypes.FETCH_BOND_RENEWAL_FAILURE,
  isLoading: false,
});

export const fetchBondRenewal =
  (id = null) =>
  async (dispatch, getState) => {
    try {
      const { session, config } = getState();
      const { bondRenewalMaxDaysNo } = config;
      const retailerId = id || session.retailer.retailerId;

      dispatch(fetchBondRenewalRequest());
      const data = await api.fetchBondRenewal({ retailerId, bondRenewalMaxDaysNo });
      dispatch(fetchBondRenewalSuccess(data));
    } catch (error) {
      console.error('BOND_RENEWAL', error);
      dispatch(fetchBondRenewalFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/bond-renewal/bond-renewal.actions.js